<div class="auth-container">
  <div class="content">
    <!-- Page content -->
    <div class="container ">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>